module.exports = __webpack_public_path__ + "assets/process-apply.7968d084.svg";